import React, { useCallback, useState } from 'react';
import CircularProgress from 'apollo-react/components/CircularProgress';
import FormSections from '../../../common/FormApproveComponents/FormSections/FormSections';
import { useMultiForm } from '../../../../contexts/MultiFormContext';
import EmbeddedHcpProfileForRequest, {
  useHcpProfileRequestMainMenuTabs,
} from './EmbeddedHcpProfileForRequest';

/**
 * FormSections + live HCP profile embed for enduser new-request / send-back
 * when the form has attach_end_user_profile_snapshot (licensing_tool).
 */
const HcpProfileFormSectionsPanel = ({
  editable = true,
  enableAddComment = false,
  isSendbackMode = false,
}) => {
  const [comments, setComments] = useState([]);
  const {
    setFormSectionsDataRef,
    syncFormSectionsData,
    errors,
    subForms,
    filledForm,
    formName,
    activeSubFormTab,
    setActiveSubFormTab,
    requestId,
    requestProgressId,
    hasHcpLicensesList,
    attachEndUserProfileSnapshot,
    isApiDataLoaded,
  } = useMultiForm();

  const hcpProfileMainMenuTabs = useHcpProfileRequestMainMenuTabs();

  const renderHcpProfileMenuContent = useCallback(
    (tabId) => <EmbeddedHcpProfileForRequest activeMainMenuTabId={tabId} />,
    []
  );

  const handleTabChange = useCallback(
    async (newTabId) => {
      try {
        await syncFormSectionsData();
      } catch (error) {
        console.error(
          '[HcpProfileFormSectionsPanel] sync before tab change failed:',
          error
        );
      }
      setActiveSubFormTab(newTabId);
    },
    [syncFormSectionsData, setActiveSubFormTab]
  );

  if (!isApiDataLoaded) {
    return (
      <div style={{ padding: 40, textAlign: 'center' }}>
        <CircularProgress />
      </div>
    );
  }

  return (
    <FormSections
      subForms={subForms}
      requestProgressId={isSendbackMode ? requestProgressId : null}
      persona="enduser"
      requestId={isSendbackMode ? requestId : null}
      filledForm={filledForm}
      requestProgress={null}
      children={null}
      handleAction={null}
      isReadOnly
      editable={editable}
      onFormDataChange={setFormSectionsDataRef}
      syncFormSectionsData={syncFormSectionsData}
      errors={{
        ...errors.formSections,
        hcpLicensesList: errors.hcpLicensesList,
      }}
      activeTab={activeSubFormTab}
      onTabChange={handleTabChange}
      showRequestBadges={false}
      enableAddComment={enableAddComment || isSendbackMode}
      hasHcpLicensesList={hasHcpLicensesList}
      isSendbackMode={isSendbackMode}
      formName={formName}
      hcpProfileMenuEnabled={Boolean(attachEndUserProfileSnapshot)}
      hcpProfileMainMenuTabs={
        attachEndUserProfileSnapshot ? hcpProfileMainMenuTabs : null
      }
      renderHcpProfileMenuContent={
        attachEndUserProfileSnapshot ? renderHcpProfileMenuContent : null
      }
      setComments={setComments}
    />
  );
};

export default HcpProfileFormSectionsPanel;
